import { z } from "zod";


export type SelectTable = {
  value: number,
  name: string
}

export type TicketRoute = "customers" | "items" | "works" | "cars" | "incomes" | "outcomes" | "banks" | "cash-boxes" | "system";
export function isTicketRoute(value: string): value is TicketRoute {
  return [
    "customers",
    "items",
    "works",
    "cars",
    "incomes",
    "outcomes",
    "banks",
    "cash-boxes",
    "system",
  ].includes(value);
}


export type TicketType = "customer" | "item" | "work" | "car" | "income" | "outcome" | "bank" | "cash-box" | "system";
export function isTicketType(value: string): value is TicketType {
  return [
    "customer",
    "item",
    "work",
    "car",
    "income",
    "outcome",
    "bank",
    "cash-box",
    "system",
  ].includes(value);
}

export type AccountType = "customer" | "income" | "outcome" | "bank" | "cash-box" | "system";
export function isAccountType(value: string): value is TicketType {
  return [
    "customer",
    "income",
    "outcome",
    "bank",
    "cash-box",
    "system",
  ].includes(value);
}



export const ticketHebTypeSchema = z.enum(["לקוח-ספק" , "פריט" , "עבודה" , "רכב" , "הכנסה" , "הוצאה" , "בנק" , "קופה" , "מערכת"]);
export type TicketHebType = z.infer<typeof ticketHebTypeSchema>;
export function isTicketHebType(value: string): value is TicketHebType {
  return [
    "לקוח-ספק",
    "פריט",
    "עבודה",
    "רכב",
    "הכנסה",
    "הוצאה",
    "בנק",
    "קופה",
    "מערכת"
  ].includes(value);
}


export const accountHebTypeSchema = z.enum(["לקוח-ספק" , "הכנסה" , "הוצאה" , "בנק" , "קופה" , "מערכת"]);
export type AccountHebType = z.infer<typeof accountHebTypeSchema>;
export function isAccountHebType(value: string): value is AccountHebType {
  return [
    "לקוח-ספק",
    "הכנסה",
    "הוצאה",
    "בנק",
    "קופה",
    "מערכת"
  ].includes(value);
}


export type FormType = "form" | "browse";
export function isFormType(value: string): value is FormType {
  return [
    "form",
    "browse",
  ].includes(value);
}
export interface Params{
  formType: FormType,
  ticketRoute: TicketRoute,
  ticketHebType: TicketHebType,
}


type PaymentType = "שיקים" | "אשראי" | "מזומן" | "העברות";
export type PaymentTable = {
  index: number
  name: PaymentType
}

export const depositType = z.enum(["הפקדה רגילה","הפקדה דחויה","הפקדת מזומן","נכיון שיקים"]);
export type DepositType = z.infer<typeof depositType>;



export const documentStatusSchema = z.enum(["סגור" , "פתוח" , "סגור חלקית"]);
export type DocumentStatus = z.infer<typeof documentStatusSchema>;
export type StatusTable = {
  index: number
  name: DocumentStatus
}


export const documentStructureType = z.enum(["account", "car", "work", "item", "document"]);
export type DocumentStructureType = z.infer<typeof documentStructureType>;
export function isDocumentStructureType(value: string): value is DocumentStructureType {
  return [
    "account",
    "car",
    "work",
    "item",
    "document",
  ].includes(value);
}


export const documentStructureHebType = z.enum(["מסמך", "תאריך ושעה", "חשבון", "רכב", "עבודה", "פריט", "תשלום"]);
export type DocumentStructureHebType = z.infer<typeof documentStructureHebType>;
export function isDocumentStructureHebType(value: string): value is DocumentStructureType {
  return [
    "מסמך",
    "תאריך ושעה",
    "חשבון",
    "רכב",
    "עבודה",
    "פריט",
    "תשלום"
  ].includes(value);
}